var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
        {
            'has-inline-label': _vm.hasInlineLabel,
            'has-placeholder': !!_vm.placeholder,
        },
        _vm.parentClass,
        'form-group' ]},[_c('label',{class:[
            {
                'move-label-to-top': _vm.moveLabelToTop,
            },
            'form-label' ],attrs:{"for":_vm.uniqueId}},[_vm._v("\n        "+_vm._s(_vm.label)+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"input-group"},[(_vm.$slots.prepend)?_vm._t("prepend"):_vm._e(),_vm._v(" "),_c('input',_vm._b({class:[
                {
                    'move-label-to-top': _vm.moveLabelToTop,
                },
                'form-control' ],attrs:{"id":_vm.uniqueId,"placeholder":_vm.inputPlaceholder,"step":_vm.step,"type":_vm.type,"pattern":"[-+]?[0-9]*[.]?[0-9]+"},domProps:{"value":_vm.inputValue},on:{"change":function($event){return _vm.handleChange($event.target.value)},"focusin":function($event){_vm.focus = true},"focusout":function($event){_vm.focus = false}}},'input',_vm.$attrs,false)),_vm._v(" "),(_vm.$slots.append)?_vm._t("append"):_vm._e()],2),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }